export default "__VITE_ASSET__0fe5a4f9__"